import React, { useEffect, useLayoutEffect } from "react";

// redux
import { useTranslation } from "react-i18next";
import { WithContext as ReactTags } from "react-tag-input";

export interface Tag {
  id: string;
  text: string;
}
interface TypesProps {
  name?: string;
  initialValue?: Tag[];
  suggestions?: Tag[];
  placeholder?: string;
  classNameInput?: string;
  bgColor?: string;
  textColor?: string;
  isChangeSelectedColor?: boolean;
  onChangeTag?: (params: Tag[]) => void;
  errDuplicate?: string;
}

const KeyCodes = {
  comma: 188,
  enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

const Keywords = ({
  name = "",
  initialValue = [],
  suggestions = [],
  placeholder = "",
  classNameInput = "",
  bgColor = "#009ef7",
  textColor = "white",
  isChangeSelectedColor = false,
  errDuplicate = "",
  onChangeTag,
}: TypesProps) => {
  const { t } = useTranslation();
  const [err, setErrors] = React.useState<boolean>(false);

  const handleDelete = (i: number) => {
    onChangeTag &&
      onChangeTag((initialValue || []).filter((tag, index) => index !== i));
  };

  const handleAddition = (tag: any) => {
    onChangeTag && onChangeTag([...initialValue, tag]);
  };

  const handleChangeInput = (event: any) => {
    const index = initialValue?.findIndex((tag) => tag.text === event);
    if (index >= 0) {
      setErrors(true);
    } else {
      setErrors(false);
    }
  };

  useEffect(() => {
    const hashtagsSelectedElement = document.querySelectorAll(
      `.hashtags-custom .tag-wrapper`
    ) as any;
    const hashtagsRemoveElement = document.querySelectorAll(
      `.hashtags-custom .tag-wrapper .ReactTags__remove`
    ) as any;
    if (hashtagsSelectedElement?.length > 0 && isChangeSelectedColor === true) {
      [...hashtagsSelectedElement]?.map((selector: any) => {
        selector.style.backgroundColor = bgColor;
        selector.style.borderColor = bgColor;
        selector.style.color = textColor;
      });

      [...hashtagsRemoveElement]?.map((selector: any) => {
        selector.style.backgroundColor = bgColor;
        selector.style.color = textColor;
      });
    } else {
      return;
    }
  }, [t, initialValue, textColor, bgColor]);

  return (
    <React.Fragment>
      <ReactTags
        tags={initialValue}
        suggestions={suggestions || []}
        delimiters={delimiters}
        handleDelete={handleDelete}
        handleAddition={handleAddition}
        handleInputChange={handleChangeInput}
        inputFieldPosition="top"
        autocomplete
        minQueryLength={1}
        allowDeleteFromEmptyInput={false}
        allowDragDrop={false}
        placeholder={placeholder}
        classNames={{
          tags: "hashtags-custom",
          tagInputField: "form-control",
        }}
      />
      {!!err && <div className="text-danger mt-2">{errDuplicate}</div>}
    </React.Fragment>
  );
};

export default Keywords;
